import {
  TInstitute,
  TAddress,
} from "../../apis/institute/institute.interfaces";

export const instituteListMock: TInstitute[] = [
  {
    id: "1",
    name: "Delhi Public School",
    type: "CBSE",
    registrationNumber: "REG-CBSE-2024-001",
    registrationDate: "2024-01-15T00:00:00.000Z",
    legalEntity: "Delhi Public School Society",
    status: "active",
    configurationCompleteness: 85,
    contactInformation: {
      primaryPhone: "+919876543210",
      secondaryPhone: "01123456789",
      email: "info@dpsdelhi.edu.in",
      website: "https://www.dpsdelhi.edu.in",
      fax: "+911123456789",
    },
    addresses: [
      {
        id: "addr-1",
        instituteId: "1",
        type: "registered",
        streetAddress: "Mathura Road, New Delhi",
        city: "New Delhi",
        state: "Delhi",
        postalCode: "110076",
        country: "India",
        isPrimary: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
      {
        id: "addr-2",
        instituteId: "1",
        type: "correspondence",
        streetAddress: "DPS Society Office, Sector 12",
        city: "Dwarka",
        state: "Delhi",
        postalCode: "110075",
        country: "India",
        isPrimary: false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "2",
    name: "St. Mary's Academy",
    type: "ICSE",
    registrationNumber: "REG-ICSE-2023-045",
    registrationDate: "2023-03-20T00:00:00.000Z",
    legalEntity: "St. Mary's Educational Trust",
    status: "active",
    configurationCompleteness: 92,
    contactInformation: {
      primaryPhone: "+919876543211",
      email: "contact@stmarysacademy.edu.in",
      website: "https://www.stmarysacademy.edu.in",
    },
    addresses: [
      {
        id: "addr-3",
        instituteId: "2",
        type: "registered",
        streetAddress: "St. Mary's Road, Bandra West",
        city: "Mumbai",
        state: "Maharashtra",
        postalCode: "400050",
        country: "India",
        isPrimary: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "3",
    name: "Maharashtra State School",
    type: "State Board",
    registrationNumber: "REG-MH-2022-128",
    registrationDate: "2022-06-10T00:00:00.000Z",
    legalEntity: "Maharashtra State Education Board",
    status: "draft",
    configurationCompleteness: 65,
    contactInformation: {
      primaryPhone: "02212345678",
      secondaryPhone: "02212345679",
      email: "info@mhstateschool.edu.in",
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "4",
    name: "International School of Excellence",
    type: "IB",
    registrationNumber: "REG-IB-2024-012",
    registrationDate: "2024-02-01T00:00:00.000Z",
    legalEntity: "International Education Foundation",
    status: "pending",
    configurationCompleteness: 45,
    contactInformation: {
      primaryPhone: "+919876543212",
      email: "admissions@ise.edu.in",
      website: "https://www.ise.edu.in",
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "5",
    name: "Cambridge Preparatory School",
    type: "IGCSE",
    registrationNumber: "REG-IGCSE-2021-089",
    registrationDate: "2021-08-15T00:00:00.000Z",
    legalEntity: "Cambridge Education Group",
    status: "archived",
    configurationCompleteness: 100,
    contactInformation: {
      primaryPhone: "+919876543213",
      secondaryPhone: "+919876543214",
      email: "info@cambridgeprep.edu.in",
      website: "https://www.cambridgeprep.edu.in",
      fax: "+911123456790",
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: new Date().toISOString(),
  },
];

export const instituteMock: TInstitute = {
  id: "1",
  name: "Delhi Public School",
  type: "CBSE",
  registrationNumber: "REG-CBSE-2024-001",
  registrationDate: "2024-01-15T00:00:00.000Z",
  legalEntity: "Delhi Public School Society",
  status: "active",
  configurationCompleteness: 85,
  contactInformation: {
    primaryPhone: "+919876543210",
    secondaryPhone: "01123456789",
    email: "info@dpsdelhi.edu.in",
    website: "https://www.dpsdelhi.edu.in",
    fax: "+911123456789",
  },
  addresses: [
    {
      id: "addr-1",
      instituteId: "1",
      type: "registered",
      streetAddress: "Mathura Road, New Delhi",
      city: "New Delhi",
      state: "Delhi",
      postalCode: "110076",
      country: "India",
      isPrimary: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: "addr-2",
      instituteId: "1",
      type: "correspondence",
      streetAddress: "DPS Society Office, Sector 12",
      city: "Dwarka",
      state: "Delhi",
      postalCode: "110075",
      country: "India",
      isPrimary: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
